import React from "react";
import "./style.css";

export default ({ bulletPoint }) => (
  <React.Fragment>
    <ul className="bullet-point-wrapper text-reg">
      { bulletPoint }
    </ul>
  </React.Fragment>
)